import React, {useEffect, useState} from "react";
import { useLocation } from "react-router-dom";
import PricingCard from "../components/PrincingCard";
import EmptyState from "../components/EmptyState";
import SEO from "../components/SEO";

import "../styles/Pricing.css";

import {toast} from "react-hot-toast";

import * as  planService from "../_services/product.plans.service";
import { toBoolean } from "../_utils/to.boolean";

const PricingPage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const productId = params.get("productId") || null;
  const proceedTo = params.get("proceedTo") || "register";
  const tenantId = params.get("tenantId") || null;

  const [loading, setLoading] = useState(false)
  const [plans, setPlans] = useState([]);

  const handleFetchPlans = async () => {
    setLoading(true);
    try {
      if(productId){
        const getPlans = await planService.get({productId:productId});
        setPlans(getPlans.data);
      } else {
        const getPlans = await planService.get({productId:"all"});
        setPlans(getPlans.data);
      }
    } catch (error) {
      setPlans([]);
      toast.error(error.message || "Unable to fetch plans");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    handleFetchPlans();
  }, []);

  return (
    <>
      <SEO
        title="Magyne Pricing | SaaS Business Management Plans"
        description="Explore Magyne SaaS plans and pricing for organizations looking for scalable business management software."
        path="/pricing"
      />

      <main>
        <section className="pricing">

          <div className="pricing-header">
            <h1>Magyne Pricing</h1>

            <p>
              Choose a Magyne plan that fits your organization's size
              and operational requirements.
            </p>
              Available Plans:
            <div className="flex flex-wrap gap-4"> 
              {
                plans.map(plan => (
                  <span className={`m-2 ${toBoolean(plan.popular) && "text-primary"}`}>{plan.productName}{" "}{plan.planName}</span>
                ))
              }
            </div>

          </div>
          {
            !loading && plans.length
            ? <>
                <div className="pricing-grid">
                  {plans.map((plan) => (
                    <PricingCard
                      productId={productId}
                      key={plan.planId}
                      plan={plan}
                      proceed={{proceedTo, tenantId}}
                    />
                  ))}

                </div>
              </>
            : !loading && !plans.length
            ? <EmptyState
                title = "No Plans Available"
                message = "There are no plans available at the moment."
                buttonText = ""
              />
            : <div>
                <div className="spinner"></div>
                <p className="text-center">
                  Loading plans. <br/>
                  Please wait...
                </p>
              </div>
          }

        </section>
      </main>
    </>
  );
};

export default PricingPage;